import { useNavigate } from "react-router-dom";
import { Trophy } from "lucide-react";
import { waNumber } from "@/lib/pdf";

const board = (rows) => {
  const m = {};
  rows.filter((r) => r.inputs.sub?.referral && r.inputs.referralMobile).forEach((r) => {
    const k = waNumber(r.inputs.referralMobile);
    const e = (m[k] ||= { name: r.inputs.referralName, mobile: r.inputs.referralMobile, enquiries: 0, admitted: [], thanked: 0 });
    e.enquiries += 1;
    if (r.status === "admitted") { e.admitted.push(r); if (r.referral_thanked) e.thanked += 1; }
  });
  return Object.values(m).sort((a, b) => b.admitted.length - a.admitted.length || b.enquiries - a.enquiries).slice(0, 10);
};

export const ReferralBoard = ({ rows }) => {
  const nav = useNavigate();
  const list = board(rows);
  return (
    <div className="rounded-lg border border-plum-900/10 bg-white p-5" data-testid="referral-board">
      <div className="mb-3 flex items-center gap-2">
        <Trophy className="h-4 w-4 text-gold-600" />
        <h2 className="font-display text-base font-bold text-plum-950">Top referring parents</h2>
        <span className="text-xs text-slate-500">· {list.length} referrer{list.length === 1 ? "" : "s"} in this range</span>
      </div>
      {!list.length ? (
        <p className="text-sm text-slate-500" data-testid="referral-board-empty">No Referral receipts in this date range.</p>
      ) : (
        <div className="divide-y divide-slate-100">
          {list.map((e, n) => (
            <div key={e.mobile} className="flex flex-wrap items-center gap-x-4 gap-y-1 py-2.5 text-sm" data-testid={`referral-row-${n}`}>
              <span className={`grid h-7 w-7 shrink-0 place-items-center rounded-full font-num text-xs font-bold ${n === 0 ? "bg-gold-400 text-plum-950" : "bg-plum-50 text-plum-800"}`}>{n + 1}</span>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-plum-950">{e.name}</div>
                <div className="font-num text-xs text-slate-500">{e.mobile}</div>
              </div>
              <div className="flex shrink-0 gap-4">
              <div className="text-right"><div className="font-num text-lg font-bold text-plum-950" data-testid={`referral-admitted-${n}`}>{e.admitted.length}</div><div className="text-[10px] uppercase tracking-wider text-slate-500">admitted</div></div>
              <div className="text-right"><div className="font-num text-lg font-semibold text-slate-600">{e.enquiries}</div><div className="text-[10px] uppercase tracking-wider text-slate-500">referred</div></div>
              </div>
              <div className="flex basis-full flex-wrap gap-1.5 pl-11 sm:basis-auto sm:pl-0">
                {e.admitted.map((r) => (
                  <button key={r.id} onClick={() => nav(`/receipts/${r.id}`)} className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${r.referral_thanked ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`}
                    title={r.referral_thanked ? "Referrer thanked" : "Not thanked yet"} data-testid={`referral-child-${r.receipt_no}`}>
                    {r.inputs.childName}{r.referral_thanked ? " ✓" : ""}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
